// Module
var code = "<div class=\"ui-grid-cell-contents\" title=\"{{row.entity.OriginalRenewal}}\">\n    <div ng-bind=\"row.entity.OriginalRenewal | date:'shortDate'\" smart-truncate></div>\n</div>";
// Exports
module.exports = code;